import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bst-svg',
    templateUrl: './svg.component.html',
    styleUrls: ['./svg.component.scss'],
    standalone: false
})
export class SVGComponent implements OnInit {

  public readonly size: number = 8;

  constructor() { }

  ngOnInit(): void {
  }

}
